import { useCallback, useRef } from "react";
import { BASE_PATHS } from "../classes/constants/pathConstants";

const useFileStorage = () => {
  // Add this cache
  const pathCache = useRef(new Map());

  const getMedicalImagePath = useCallback(
    async (tenantId, patientId, imageId, imageFileName) => {
      // Add this cache check
      const cacheKey = `${tenantId}_${patientId}_${imageId}_${imageFileName}`;
      if (pathCache.current.has(cacheKey)) {
        return pathCache.current.get(cacheKey);
      }

      if (!tenantId || !patientId || !imageId || !imageFileName) {
      }

      const safetenantId = String(tenantId || "");
      const safePatientId = String(patientId || "");
      const safeImageId = String(imageId || "");
      const safeFileName = String(imageFileName || "");

      const path = `${BASE_PATHS.IMAGES}/${safetenantId}/${safePatientId}/${safeImageId}/${safeFileName}`;

      // Add this to save to cache
      pathCache.current.set(cacheKey, path);

      return path;
    },
    []
  );

  return {
    getMedicalImagePath,
  };
};

export default useFileStorage;
